import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-col bg-background-secondary p-4"
}
const _hoisted_2 = {
  key: 0,
  class: "flex flex-row bg-primary-light p-2 rounded items-center justify-between"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, " To finalize the onboarding process, you have to complete all the following tasks. ", -1)
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "flex flex-row items-center my-4 text-gray-500" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "Completed tasks", -1)
const _hoisted_7 = { class: "bg-background p-2 rounded ml-2" }
const _hoisted_8 = ["onClick", "disabled"]
const _hoisted_9 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-4 w-4 text-white m-auto",
  viewBox: "0 0 20 20",
  fill: "currentColor"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "ml-4 text-gray-500" }
const _hoisted_13 = {
  key: 1,
  class: "mt-2"
}
const _hoisted_14 = {
  key: 0,
  class: "text-gray-400 italic ml-4"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "font-medium" }, "ENTER ", -1)
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" to create ")
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.status !== 'dismissed')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.status !== 'hired')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.finishOnboarding && _ctx.finishOnboarding(...args))),
                class: "btn-filled-sm disabled:cursor-not-allowed disabled:opacity-50",
                disabled: _ctx.pending < _ctx.tasks.length
              }, " Finish hiring process ", 8, _hoisted_4)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.pending) + "/" + _toDisplayString(_ctx.tasks.length), 1)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tasks, (task, i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: i,
            class: "flex flex-row items-center mb-1"
          }, [
            _createElementVNode("button", {
              onClick: ($event: any) => (_ctx.changeStatus(i)),
              class: _normalizeClass(["w-5 h-5 rounded-full", {
          'bg-gray-300': !task.completed,
          'bg-primary': task.completed,
        }]),
              disabled: _ctx.status === 'hired'
            }, [
              (task.completed)
                ? (_openBlock(), _createElementBlock("svg", _hoisted_9, _hoisted_11))
                : _createCommentVNode("", true)
            ], 10, _hoisted_8),
            _createElementVNode("span", _hoisted_12, _toDisplayString(task.description), 1)
          ]))
        }), 128)),
        (_ctx.status !== 'hired')
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newTask) = $event)),
                type: "text",
                placeholder: "Add new task",
                class: "bg-background rounded p-4 focus:outline-none",
                onKeyup: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.addTask && _ctx.addTask(...args)), ["enter"]))
              }, null, 544), [
                [_vModelText, _ctx.newTask]
              ]),
              (_ctx.newTask)
                ? (_openBlock(), _createElementBlock("span", _hoisted_14, _hoisted_17))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}